import { Component, Event, EventEmitter, forceUpdate, Fragment, h, Prop } from '@stencil/core';
import { PersonDoc, RfiDoc, RFISettingsDoc } from 'common';
import { PersonInfoModal } from '../../components/concourse-person-selector/person-info-modal';

@Component({
  tag: 'view-columns',
  styleUrl: 'concourse-rfis.css',
  //shadow: true,
})
export class ViewColumns {
  @Prop() canWrite: boolean;
  @Prop({ mutable: true }) rfis: RfiDoc[] = [];
  @Prop() people: PersonDoc[];
  @Prop() settings: RFISettingsDoc;

  @Event() rfisEdited: EventEmitter<RfiDoc[]>;
  @Event() rfiSelected: EventEmitter<RfiDoc>;

  private dragging: boolean = false;

  async componentDidLoad() {
    // Don't allow drag/drop if the user can't write
    if (this.canWrite) {
      const containers = document.querySelectorAll('.cards-reorder-group');
      containers.forEach(container => {
        container.addEventListener('ionItemReorder', async (e: CustomEvent) => {
          console.log('ionItemReorder', e);
          this.dragging = true;
          await e.detail.complete();

          // wait for the drop to finish.... not sure if this was necessary before....
          setTimeout(() => this.storeCardsOrdered(container), 100);
        });
      });
    }
  }

  storeCardsOrdered(container) {
    console.log('storeCardsOrdered', container);

    const rfis = [];
    container.childNodes.forEach((card: HTMLElement, index) => {
      // The draggable cards are given the rfi number as the id
      const rfi: RfiDoc = this.rfis.find(rfi => rfi._id == card.id);
      if (rfi) {
        rfi.pos = index;
        rfis.push(rfi);
        console.log('num:', rfi.code);
      }
    });

    // Super nasty hack to clear the render method.
    // Without this, the rows seem to get re-used with the old data.
    this.rfis = [];
    forceUpdate(this);

    this.rfisEdited.emit(rfis);
    setTimeout(() => (this.dragging = false), 1000);
  }

  onCardClick(rfi: RfiDoc) {
    if (this.dragging) {
      console.log('ignoring click while dragging');
      return;
    }
    this.rfiSelected.emit(rfi);
  }

  handlePersonClick(event, person: PersonDoc) {
    event.stopPropagation();
    event.preventDefault();
    PersonInfoModal.presentModal(person);
  }

  groupByState(rfis: RfiDoc[]): Record<string, RfiDoc[]> {
    return rfis.reduce((acc, rfi) => {
      const stateId = rfi.status_history?.length ? rfi.status_history[rfi.status_history.length - 1].state_id : null;
      const action = stateId ? rfi.states?.find(s => s.id == stateId)?.action : 'Draft';
      acc[action] = acc[action] || [];
      acc[action].push(rfi);
      return acc;
    }, {} as Record<string, RfiDoc[]>);
  }

  render() {
    const rfisByState = this.groupByState(this.rfis);
    return (
      <Fragment>
        <div class="rfis-container">
          {Object.entries(rfisByState).map(([action, rfis]) => {
            return (
              <div class="rfis-state">
                <div class="state-title">
                  <h2>{action}</h2>
                  <span>{rfis.length}</span>
                </div>
                <ion-reorder-group class="cards-reorder-group" disabled="false">
                  {rfis.map(rfi => {
                    return <rfi-card id={rfi._id} key={`pos-${rfi.pos}`} people={this.people} rfi={rfi} onClick={() => this.onCardClick(rfi)}></rfi-card>;
                  })}
                </ion-reorder-group>
              </div>
            );
          })}
        </div>
      </Fragment>
    );
  }
}
